import EventEmitter from 'eventemitter3';

var emitter = new EventEmitter();

export const useEmitter = () => {
  return {
    emitter,
  };
};
